const fetchGiftCardDenomination = (payload) => {
    return new Promise((res, rej) => {
        axios.defaults.headers.common["Authorization"] = localStorage.getItem("consumer_token");
        axios.post('giftcard/denominations', payload)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};

const searchStore = (payload) => {
    return new Promise((res, rej) => {
        axios.defaults.headers.common["Authorization"] = localStorage.getItem("consumer_token");
        axios.post('giftcard/searchstore', payload)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};

const purchaseGiftCard = (payload) => {
    return new Promise((res, rej) => {
        axios.defaults.headers.common["Authorization"] = localStorage.getItem("consumer_token");
        axios.post('giftcard/purchase', payload)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};

// Get consumer gift card details for a given status_type (all|pending|success|redeemed)
const getGiftCardDetails = (payload) => {
    return new Promise((res, rej) => {
        axios.defaults.headers.common["Authorization"] = localStorage.getItem("consumer_token");
        // Backend route: /consumer/giftcard/details; baseURL likely includes "/consumer"
        axios.post('giftcard/details', payload)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};

// Share a gift card with another user
const shareGiftCard = (payload) => {
    return new Promise((res, rej) => {
        axios.defaults.headers.common["Authorization"] = localStorage.getItem("consumer_token");
        axios.post('giftcard/share', payload)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};

// Get shared gift card details received by the user with pagination
const getGiftCardDetailsShared = (payload) => {
    return new Promise((res, rej) => {
        axios.defaults.headers.common["Authorization"] = localStorage.getItem("consumer_token");
        axios.post('giftcard-detail-shared', payload)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};

const getTransactionDate = (payload) => {
    return new Promise((res, rej) => {
        axios.defaults.headers.common["Authorization"] = localStorage.getItem("consumer_token");
        axios.get('/fetch-giftcard-initaldate', payload)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
}

const fetchAppreciationlist = (payload) => {
    return new Promise((res, rej) => {
        axios.defaults.headers.common["Authorization"] = localStorage.getItem("consumer_token");
        axios.post('/fetch-appreciation-list', payload)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
}

// Send appreciation (Thank You button)
const sendAppreciation = (payload) => {
    return new Promise((res, rej) => {
        axios.defaults.headers.common["Authorization"] = localStorage.getItem("consumer_token");
        axios.post('gift-card-appreciation', payload)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};

// Update gift card share status (Cool button)
const updateGiftCardShareStatus = (payload) => {
    return new Promise((res, rej) => {
        axios.defaults.headers.common["Authorization"] = localStorage.getItem("consumer_token");
        axios.post('gift-card-share-status', payload)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};

const readAppreciation = (payload) => {
    return new Promise((res, rej) => {
        axis.defaults.headers,common["Authorization"] = localStorage.getItem("consumer_token");
        axios.post('/read-appreciation', payload)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
}

// Validate coupon code for gift card redemption
const validateCouponCode = (payload) => {
    return new Promise((res, rej) => {
        axios.defaults.headers.common["Authorization"] = localStorage.getItem("consumer_token");
        axios.post('giftcard/validate-coupon', payload)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};

// Redeem gift card by coupon code
const redeemGiftCard = (payload) => {
    return new Promise((res, rej) => {
        axios.defaults.headers.common["Authorization"] = localStorage.getItem("consumer_token");
        axios.post('giftcard/redeem', payload)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};

export default {
    fetchGiftCardDenomination,
    searchStore,
    purchaseGiftCard,
    getGiftCardDetails,
    shareGiftCard,
    getGiftCardDetailsShared,
    getTransactionDate,
    fetchAppreciationlist,
    sendAppreciation,
    updateGiftCardShareStatus,
    readAppreciation,
    validateCouponCode,
    redeemGiftCard
};